/** Catálogo de ventanas de la app para RBAC por sección.
 *  Permisos: sec.{unitKey}.{itemKey}.{read|create|update|delete}
 *  Mantener hrefs alineados con AppRouter.
 */

export const SECTION_ACTIONS = [
  { key: 'read', label: 'Visible', short: 'Ver', description: 'Muestra la sección y permite consultar' },
  { key: 'create', label: 'Crear', short: 'Crear', description: 'Crear registros en esa ventana' },
  { key: 'update', label: 'Editar', short: 'Editar', description: 'Modificar registros existentes' },
  { key: 'delete', label: 'Borrar', short: 'Borrar', description: 'Eliminar registros' },
];

const PINTURAS_READ = ['commercial.read', 'products.read', 'production.read', 'procurement.read'];

export const SECTION_TREE = [
  {
    unit: 'BackOffice',
    unitKey: 'backoffice',
    groups: [
      {
        key: 'administration',
        title: 'Administración',
        moduleGroup: 'backoffice',
        legacyRead: ['backoffice.dashboard'],
        legacyWrite: [],
        items: [
          { key: 'dashboard', label: 'Dashboard', href: '/backoffice/dashboard' },
          { key: 'analytics', label: 'Analíticas', href: '/backoffice/analytics' },
          { key: 'monitoring', label: 'Monitoreo', href: '/backoffice/monitoring' },
          { key: 'settings', label: 'Ajustes', href: '/backoffice/settings' },
        ],
      },
      {
        key: 'human-resources',
        title: 'Recursos Humanos',
        moduleGroup: 'backoffice',
        legacyRead: ['backoffice.dashboard', 'finance.read', 'admin.users'],
        legacyWrite: [],
        items: [
          { key: 'collaborators', label: 'Colaboradores', href: '/backoffice/hr/collaborators' },
          { key: 'recruitment', label: 'Reclutamiento', href: '/backoffice/hr/recruitment' },
          { key: 'performance', label: 'Desempeño', href: '/backoffice/hr/performance' },
          { key: 'training', label: 'Capacitación', href: '/backoffice/hr/training' },
          { key: 'attendance', label: 'Asistencia', href: '/backoffice/hr/attendance' },
        ],
      },
      {
        key: 'finance',
        title: 'Finanzas',
        moduleGroup: 'finance',
        legacyRead: ['finance.read'],
        legacyWrite: ['finance.write'],
        items: [
          { key: 'finance-overview', label: 'Overview', href: '/backoffice/finance/overview' },
          { key: 'treasury', label: 'Tesorería', href: '/backoffice/finance/treasury' },
          { key: 'accounting', label: 'Contabilidad', href: '/backoffice/finance/accounting' },
          { key: 'stakeholders', label: 'Stakeholders', href: '/backoffice/finance/stakeholders' },
          { key: 'taxes', label: 'Impuestos', href: '/backoffice/finance/taxes' },
          { key: 'purchases', label: 'Compras', href: '/backoffice/finance/purchases' },
          { key: 'budget', label: 'Presupuesto', href: '/backoffice/finance/budget' },
          { key: 'payroll', label: 'Nómina', href: '/backoffice/finance/payroll' },
          { key: 'statements', label: 'Estados Financieros', href: '/backoffice/finance/statements' },
          { key: 'financing', label: 'Financiamiento', href: '/backoffice/finance/financing' },
          { key: 'finance-settings', label: 'Ajustes', href: '/backoffice/finance/settings' },
        ],
      },
    ],
  },
  {
    unit: 'Pinturas',
    unitKey: 'pinturas',
    groups: [
      {
        key: 'products',
        title: 'Productos',
        moduleGroup: 'products',
        legacyRead: ['products.read'],
        legacyWrite: ['products.write'],
        items: [
          { key: 'paint-products', label: 'Pinturas', href: '/pinturas/products/paint' },
          { key: 'upselling', label: 'Upselling', href: '/pinturas/products/upselling' },
          { key: 'paint-competitors', label: 'Competidores', href: '/pinturas/products/competitors' },
        ],
      },
      {
        key: 'commercial',
        title: 'Comercial',
        moduleGroup: 'commercial',
        legacyRead: ['commercial.read'],
        legacyWrite: ['commercial.write'],
        items: [
          { key: 'commercial-summary', label: 'Resumen', href: '/pinturas/commercial/summary' },
          { key: 'commercial-config', label: 'Ajustes', href: '/pinturas/commercial/config' },
          { key: 'commercial-analysis', label: 'Análisis', href: '/pinturas/commercial/analysis' },
          { key: 'commercial-leads', label: 'Leads', href: '/pinturas/commercial/leads' },
          { key: 'commercial-prospecting', label: 'Prospección', href: '/pinturas/commercial/prospecting' },
          { key: 'commercial-tenders', label: 'Licitaciones', href: '/pinturas/commercial/tenders' },
          { key: 'commercial-quotes', label: 'Cotizaciones', href: '/pinturas/commercial/quotes' },
          { key: 'commercial-sales', label: 'Ventas', href: '/pinturas/commercial/sales' },
          { key: 'commercial-requests', label: 'Solicitudes', href: '/pinturas/commercial/requests' },
          { key: 'commercial-logistics', label: 'Despachos', href: '/pinturas/commercial/logistics' },
          { key: 'commercial-after-sales', label: 'Post-Venta', href: '/pinturas/commercial/after-sales' },
        ],
      },
      {
        key: 'production',
        title: 'Producción',
        moduleGroup: 'production',
        legacyRead: ['production.read'],
        legacyWrite: ['production.write'],
        items: [
          { key: 'production-config', label: 'Ajustes', href: '/pinturas/production/config' },
          { key: 'raw-materials', label: 'Materias Primas', href: '/pinturas/production/raw-materials' },
          { key: 'formulas', label: 'Fórmulas', href: '/pinturas/production/formulas' },
          { key: 'planning', label: 'Planificación', href: '/pinturas/production/planning' },
          { key: 'shop', label: 'Producción', href: '/pinturas/production/shop' },
          { key: 'quality-control', label: 'Control de Calidad', href: '/pinturas/quality' },
          { key: 'inventory', label: 'Inventario', href: '/pinturas/inventory' },
        ],
      },
      {
        key: 'acquisitions',
        title: 'Adquisiciones',
        moduleGroup: 'procurement',
        legacyRead: ['procurement.read'],
        legacyWrite: ['procurement.write'],
        items: [
          { key: 'acquisitions-summary', label: 'Resumen', href: '/pinturas/acquisitions/summary' },
          { key: 'acquisitions-config', label: 'Ajustes', href: '/pinturas/acquisitions/config' },
          { key: 'suppliers', label: 'Proveedores', href: '/pinturas/suppliers' },
          { key: 'purchase-requests', label: 'Solicitudes', href: '/pinturas/acquisitions/purchase-requests' },
          { key: 'purchase-orders', label: 'Órdenes de Compra', href: '/pinturas/acquisitions/purchase-orders' },
          { key: 'purchase-receipts', label: 'Recepción', href: '/pinturas/acquisitions/receipts' },
          { key: 'purchase-quotations', label: 'Cotizaciones', href: '/pinturas/acquisitions/quotations' },
          { key: 'procurement-catalog', label: 'Catálogo', href: '/pinturas/acquisitions/catalog' },
          { key: 'procurement-inventory', label: 'Inventarios', href: '/pinturas/acquisitions/inventory' },
        ],
      },
      {
        key: 'quality',
        title: 'Gestión de Calidad',
        moduleGroup: 'production',
        legacyRead: PINTURAS_READ,
        legacyWrite: ['production.write'],
        ungatedFallback: true,
        items: [
          { key: 'testing', label: 'Pruebas', href: '/pinturas/testing' },
          { key: 'nonconformities', label: 'No Conformidades', href: '/pinturas/quality/nonconformities' },
          { key: 'certificates', label: 'Certificados', href: '/pinturas/quality/certificates' },
          { key: 'audits', label: 'Auditorías', href: '/pinturas/quality/audits' },
        ],
      },
    ],
  },
  {
    unit: 'Aditivos',
    unitKey: 'aditivos',
    groups: [
      {
        key: 'additives-products',
        title: 'Productos',
        moduleGroup: 'additives',
        legacyRead: ['additives.commercial.read'],
        legacyWrite: ['additives.commercial.write'],
        items: [
          { key: 'additives-standards', label: 'Normas y Certificaciones', href: '/aditivos/products/standards' },
          { key: 'additives-phenox', label: 'Productos PhenoX', href: '/aditivos/products/phenox' },
          { key: 'additives-competitors', label: 'Competidores', href: '/aditivos/products/competitors' },
        ],
      },
      {
        key: 'additives-ip',
        title: 'Propiedad Intelectual',
        moduleGroup: 'additives',
        legacyRead: ['additives.commercial.read'],
        legacyWrite: ['additives.commercial.write'],
        items: [
          { key: 'additives-patents', label: 'Patentes', href: '/aditivos/products/patents' },
          { key: 'additives-formulas', label: 'Fórmulas', href: '/aditivos/products/formulas' },
        ],
      },
      {
        key: 'additives-commercial',
        title: 'Comercial',
        moduleGroup: 'additives',
        legacyRead: ['additives.commercial.read'],
        legacyWrite: ['additives.commercial.write'],
        items: [
          { key: 'additives-commercial-summary', label: 'Resumen', href: '/aditivos/commercial/summary' },
          { key: 'additives-commercial-config', label: 'Ajustes', href: '/aditivos/commercial/config' },
          { key: 'additives-commercial-leads', label: 'Leads', href: '/aditivos/commercial/leads' },
          { key: 'additives-commercial-prospecting', label: 'Prospección', href: '/aditivos/commercial/prospecting' },
          { key: 'additives-commercial-market', label: 'Mercado', href: '/aditivos/commercial/market' },
        ],
      },
      {
        key: 'formulation',
        title: 'Formulación',
        moduleGroup: 'additives',
        legacyRead: ['additives.commercial.read'],
        legacyWrite: ['additives.commercial.write'],
        ungatedFallback: true,
        items: [
          { key: 'recipes', label: 'Recetas', href: '/aditivos/recipes' },
          { key: 'mixing', label: 'Mezclado', href: '/aditivos/mixing' },
        ],
      },
      {
        key: 'additives-testing',
        title: 'Pruebas',
        moduleGroup: 'additives',
        legacyRead: ['additives.commercial.read'],
        legacyWrite: ['additives.commercial.write'],
        ungatedFallback: true,
        items: [
          { key: 'additives-testing', label: 'Pruebas', href: '/aditivos/testing' },
          { key: 'analysis', label: 'Análisis', href: '/aditivos/analysis' },
        ],
      },
      {
        key: 'storage',
        title: 'Almacenamiento',
        moduleGroup: 'additives',
        legacyRead: ['additives.commercial.read'],
        legacyWrite: ['additives.commercial.write'],
        ungatedFallback: true,
        items: [
          { key: 'storage', label: 'Almacén', href: '/aditivos/storage' },
          { key: 'logistics', label: 'Despachos', href: '/aditivos/logistics' },
        ],
      },
    ],
  },
  {
    unit: 'Servicios',
    unitKey: 'servicios',
    groups: [
      {
        key: 'maintenance',
        title: 'Mantenimiento',
        moduleGroup: 'servicios',
        legacyRead: [],
        legacyWrite: [],
        ungatedFallback: true,
        items: [
          { key: 'maintenance', label: 'Mantenimiento', href: '/servicios/maintenance' },
          { key: 'repairs', label: 'Reparaciones', href: '/servicios/repairs' },
        ],
      },
      {
        key: 'installation',
        title: 'Instalación',
        moduleGroup: 'servicios',
        legacyRead: [],
        legacyWrite: [],
        ungatedFallback: true,
        items: [
          { key: 'installation', label: 'Instalaciones', href: '/servicios/installation' },
          { key: 'support', label: 'Soporte', href: '/servicios/support' },
        ],
      },
      {
        key: 'billing',
        title: 'Facturación',
        moduleGroup: 'servicios',
        legacyRead: [],
        legacyWrite: [],
        ungatedFallback: true,
        items: [
          { key: 'quotes', label: 'Cotizaciones', href: '/servicios/billing/quotes' },
          { key: 'invoices', label: 'Facturas', href: '/servicios/billing/invoices' },
          { key: 'payments', label: 'Pagos', href: '/servicios/billing/payments' },
        ],
      },
    ],
  },
  {
    unit: 'Administración',
    unitKey: 'sistema',
    groups: [
      {
        key: 'admin',
        title: 'Administración',
        moduleGroup: 'admin',
        legacyRead: ['admin.access', 'admin.users', 'admin.roles', 'admin.permissions'],
        legacyWrite: ['admin.users', 'admin.roles', 'admin.permissions'],
        items: [
          { key: 'users', label: 'Usuarios', href: '/sistema/admin/users', legacyRead: ['admin.users'] },
          {
            key: 'permissions',
            label: 'Roles y permisos',
            href: '/sistema/admin/permissions',
            legacyRead: ['admin.permissions', 'admin.roles'],
          },
          { key: 'maintenance', label: 'Mantención', href: '/sistema/admin/maintenance', legacyRead: ['admin.access'] },
        ],
      },
      {
        key: 'company',
        title: 'Company',
        moduleGroup: 'admin',
        legacyRead: ['admin.access'],
        legacyWrite: ['admin.access'],
        items: [
          { key: 'general', label: 'General', href: '/sistema/company/general' },
          { key: 'configuration', label: 'Ajustes', href: '/sistema/company/configuration' },
        ],
      },
      {
        key: 'monitoring',
        title: 'Monitoreo',
        moduleGroup: 'admin',
        legacyRead: ['admin.access'],
        legacyWrite: ['admin.access'],
        items: [
          { key: 'activity', label: 'Actividad', href: '/sistema/monitoring/activity' },
          {
            key: 'sessions',
            label: 'Sesiones',
            href: '/sistema/monitoring/sessions',
            legacyRead: ['monitoring.presence', 'admin.access'],
          },
        ],
      },
      {
        key: 'datos',
        title: 'Datos',
        moduleGroup: 'system',
        legacyRead: ['admin.access'],
        legacyWrite: [],
        items: [
          {
            key: 'importacion',
            label: 'Importación',
            href: '/sistema/datos/importacion',
            legacyRead: ['system.data.import'],
            legacyWrite: ['system.data.import'],
          },
          {
            key: 'exportacion',
            label: 'Exportación',
            href: '/sistema/datos/exportacion',
            legacyRead: ['system.data.export'],
            legacyWrite: ['system.data.export'],
          },
        ],
      },
    ],
  },
];

export function flattenSectionCatalog(tree = SECTION_TREE) {
  const rows = [];
  tree.forEach((unit) => {
    unit.groups.forEach((group) => {
      group.items.forEach((item) => {
        rows.push({
          id: `${unit.unitKey}.${item.key}`,
          unit: unit.unit,
          unitKey: unit.unitKey,
          groupKey: group.key,
          groupTitle: group.title,
          moduleGroup: item.moduleGroup || group.moduleGroup,
          key: item.key,
          label: item.label,
          href: item.href,
          legacyRead: item.legacyRead || group.legacyRead || [],
          legacyWrite: item.legacyWrite || group.legacyWrite || [],
          ungatedFallback: item.ungatedFallback ?? group.ungatedFallback ?? false,
        });
      });
    });
  });
  return rows;
}

export const SECTION_CATALOG = flattenSectionCatalog();

export const SECTION_BY_HREF = SECTION_CATALOG.slice()
  .sort((a, b) => b.href.length - a.href.length)
  .reduce((map, section) => {
    map[section.href] = section;
    return map;
  }, {});

export function sectionActionCode(section, action) {
  if (!section) return '';
  return `sec.${section.unitKey}.${section.key}.${action}`;
}

export function isSectionPermissionCode(code = '') {
  return String(code || '').startsWith('sec.');
}

export function findSectionByPath(pathname = '') {
  const path = String(pathname || '').split('?')[0];
  if (!path) return null;
  const exact = SECTION_BY_HREF[path];
  if (exact) return exact;
  for (const section of SECTION_CATALOG.slice().sort((a, b) => b.href.length - a.href.length)) {
    if (path === section.href || path.startsWith(`${section.href}/`)) return section;
  }
  return null;
}

export function describeSectionPermission(code = '') {
  const match = String(code).match(/^sec\.([^.]+)\.([^.]+)\.(read|create|update|delete)$/);
  if (!match) return null;
  const [, unitKey, key, action] = match;
  const section = SECTION_CATALOG.find((row) => row.unitKey === unitKey && row.key === key);
  const actionMeta = SECTION_ACTIONS.find((item) => item.key === action);
  if (!section || !actionMeta) return null;
  return `${section.unit} · ${section.groupTitle} · ${section.label} · ${actionMeta.label}`;
}

const ACTION_LABELS = {
  read: 'ver',
  create: 'crear',
  update: 'editar',
  delete: 'borrar',
};

export function sectionPermissionSeed() {
  return SECTION_CATALOG.flatMap((section) =>
    SECTION_ACTIONS.map((action) => ({
      code: sectionActionCode(section, action.key),
      module: section.unitKey,
      description: `${section.unit} / ${section.groupTitle} / ${section.label}: ${ACTION_LABELS[action.key]}`,
    }))
  );
}

/** Permisos de módulo que se recalcan al guardar la matriz (no se dejan “sueltos”). */
export const DERIVED_MODULE_CODES = [
  'commercial.read',
  'commercial.write',
  'products.read',
  'products.write',
  'organizations.read',
  'organizations.write',
  'contacts.read',
  'contacts.write',
  'quotations.read',
  'quotations.write',
  'finance.read',
  'finance.write',
  'backoffice.dashboard',
  'production.read',
  'production.write',
  'procurement.read',
  'procurement.write',
  'additives.commercial.read',
  'additives.commercial.write',
  'admin.users',
  'admin.roles',
  'admin.permissions',
  'admin.access',
  'system.data.import',
  'system.data.export',
  'monitoring.presence',
];

export function derivedModuleCodesFromSections(selectedCodes) {
  const set = new Set(selectedCodes || []);
  const has = (unitKey, key, action) => set.has(`sec.${unitKey}.${key}.${action}`);
  const anyAction = (predicate, actions) =>
    SECTION_CATALOG.some((section) => predicate(section) && actions.some((action) => has(section.unitKey, section.key, action)));

  const codes = [];
  const add = (code, enabled) => {
    if (enabled) codes.push(code);
  };
  const allActions = ['read', 'create', 'update', 'delete'];
  const writeActions = ['create', 'update', 'delete'];

  add(
    'backoffice.dashboard',
    anyAction((s) => s.unitKey === 'backoffice' && s.moduleGroup === 'backoffice', allActions)
  );
  add(
    'finance.read',
    anyAction((s) => s.moduleGroup === 'finance', allActions)
  );
  add(
    'finance.write',
    anyAction((s) => s.moduleGroup === 'finance', writeActions)
  );
  add(
    'commercial.read',
    anyAction((s) => s.unitKey === 'pinturas' && s.moduleGroup === 'commercial', allActions)
  );
  add(
    'commercial.write',
    anyAction((s) => s.unitKey === 'pinturas' && s.moduleGroup === 'commercial', writeActions)
  );
  add(
    'products.read',
    anyAction((s) => s.unitKey === 'pinturas' && s.moduleGroup === 'products', allActions)
  );
  add(
    'products.write',
    anyAction((s) => s.unitKey === 'pinturas' && s.moduleGroup === 'products', writeActions)
  );
  add(
    'production.read',
    anyAction((s) => s.unitKey === 'pinturas' && s.moduleGroup === 'production', allActions)
  );
  add(
    'production.write',
    anyAction((s) => s.unitKey === 'pinturas' && s.moduleGroup === 'production', writeActions)
  );
  add(
    'procurement.read',
    anyAction((s) => s.moduleGroup === 'procurement', allActions)
  );
  add(
    'procurement.write',
    anyAction((s) => s.moduleGroup === 'procurement', writeActions)
  );
  add(
    'additives.commercial.read',
    anyAction((s) => s.unitKey === 'aditivos', allActions)
  );
  add(
    'additives.commercial.write',
    anyAction((s) => s.unitKey === 'aditivos', writeActions)
  );

  const commercialMutate = anyAction(
    (s) => s.unitKey === 'pinturas' && s.moduleGroup === 'commercial',
    writeActions
  );
  const commercialRead = anyAction(
    (s) => s.unitKey === 'pinturas' && s.moduleGroup === 'commercial',
    allActions
  );
  add('organizations.read', commercialRead);
  add('organizations.write', commercialMutate);
  add('contacts.read', commercialRead);
  add('contacts.write', commercialMutate);
  add(
    'quotations.read',
    allActions.some((action) => has('pinturas', 'commercial-quotes', action) || has('pinturas', 'commercial-tenders', action))
  );
  add(
    'quotations.write',
    writeActions.some(
      (action) => has('pinturas', 'commercial-quotes', action) || has('pinturas', 'commercial-tenders', action)
    )
  );

  add('admin.users', allActions.some((action) => has('sistema', 'users', action)));
  add('admin.roles', allActions.some((action) => has('sistema', 'permissions', action)));
  add('admin.permissions', allActions.some((action) => has('sistema', 'permissions', action)));
  add(
    'admin.access',
    anyAction((s) => s.unitKey === 'sistema', allActions)
  );
  add('system.data.import', allActions.some((action) => has('sistema', 'importacion', action)));
  add('system.data.export', allActions.some((action) => has('sistema', 'exportacion', action)));
  add('monitoring.presence', allActions.some((action) => has('sistema', 'sessions', action)));

  return Array.from(new Set(codes));
}
